import { createSlice } from "@reduxjs/toolkit";
import axios from 'axios';

const svrUrl = process.env.REACT_APP_SERVER_URL;

export const reduxSlice = createSlice({
    name: 'name_reduxSlice',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {
        value1: 1,
        list: [],
        selectedList: {},
        boardTitle:{},
        boardKind: '',
        initialPage: 0,
        isFileListSelect: false,
        isLoggedIn: false, 
        isStudent: false,     
        isLoginPage: false,
        userInfo: {},
        isRefreshMun: false,
        testNm: null,
        testList: [],
        selectedTestListItem: {},
        headerInfo: {title:'제목', direction: -1},
        selectedClassList: {},
        isAdmin: false,
        isSubmenuVisible: false,
        selectedDate: new Date().toISOString(),  // ISO 문자열로 저장
  
        // selectedQueCode: null,//잠시 보류
    },
    
    reducers: {

        setList: (state, action) => {
            state.list = action.payload;
        },

        setSelectedList: (state, action) => {
            state.selectedList = action.payload;
        },
      
        setBoardTitle: (state, action) => {
            state.boardTitle = action.payload;
        },
        setBoardKind: (state, action) => {
            state.boardKind = action.payload;
        },
        setInitialPage: (state, action) => {
            state.initialPage = action.payload;
        },
        setIsFileListSelect: (state, action) => {
            state.isFileListSelect = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setIsStudent: (state, action) => {
            state.isStudent = action.payload;
        },
        setIsLoginPage: (state, action) => {
            state.isLoginPage = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setIsRefreshMun: (state, action) => {
            state.isRefreshMun = action.payload;
        },

        setTestNm: (state, action) => {
            state.testNm = action.payload;
        },

        listUpdate: (state, action) => {
            const index = state.list.findIndex(item => item.sno === action.payload.sno);
            if (index !== -1) {
              state.list[index] = {...state.list[index], ...action.payload};
            }
        },

        setTestList: (state, action) => {
            state.testList = action.payload;
        },
        
        setSelectedTestListItem: (state, action) => {
            state.selectedTestListItem = action.payload;
        },
         //dispatch(setHeaderInfo({title: label, direction: -1})); 한개만 해도 된다.
         setHeaderInfo: (state, action) => {
            const updates = action.payload;
            for (const key in updates) {
                if (key in state.headerInfo) {
                    state.headerInfo[key] = updates[key];
                }
            }
        },
        setSelectedClassList: (state, action) => {
            state.selectedClassList = action.payload;
        },
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setIsSubmenuVisible: (state, action) => {
            state.isSubmenuVisible = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        },

        // setSelectedQueCode: (state, action) => {//문제 보이기
        //     state.selectedQueCode = action.payload;
        // },
        

    }


});



export const { 
    increment, 
    setList, setList2,
    setBoardTitle, 
    setBoardKind,
    setSelectedList,
    setInitialPage,
    setIsFileListSelect,
    setIsLoggedIn, setIsStudent, setIsLoginPage,
    setUserInfo,
    setIsRefreshMun,
    listUpdate,
    setTestNm,
    setTestList, setSelectedTestListItem,
    setHeaderInfo,

    setSelectedClassList,
    setIsAdmin,
    setIsSubmenuVisible,
    setSelectedDate,

    // setSelectedQueCode,
} = reduxSlice.actions;

export default reduxSlice.reducer;

